// in src/Dashboard.js
import * as React from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import RecentlyPrintedOnStationDash from "./RecentlyPrintedOnStationDash";
import RecentlyPrintedEntireCompany from "./RecentlyPrintedEntireCompany";
import Version from "../../framework/Version";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

export default (props) => {
    const classes = useStyles();
    return (

        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={9}>
                    <RecentlyPrintedOnStationDash {...props}/>
                </Grid>
                <Grid item xs={9}>
                    <RecentlyPrintedEntireCompany {...props}/>
                </Grid>
                <Grid item xs={12}>
                    <Version />
                </Grid>
            </Grid>
        </div>

    );
};
